<template>
  <div class="w-100 d-flex justify-content-center">
    <form class="pl-5 pr-5 main-view" @submit.prevent="nextAction()" id="mainForm">
      <div class="row mt-0">
        <div class="col-3 text-start">
          <span class="fw-bold">責任者名</span><span class="mustlbl ms-2">必須</span>
        </div>
        <div class="col-7">
          <div class="d-flex flex-row gap-3">
            <div>
              <div class="mb-1 text-start">
                <label for="inputName" class="form-label fw-bold m-0">氏名</label>
                <input
                  type="text"
                  id="inputName"
                  v-model="name01"
                  class="border border-1 border-gray rounded mt-1 acry-input form-control"
                  placeholder="姓"
                  required
                />
              </div>
            </div>
            <div>
              <div class="mb-1 text-start">
                <label for="inputName2" class="form-label m-0" style="visibility: hidden"
                  >名</label
                >
                <input
                  type="text"
                  id="inputName2"
                  v-model="name02"
                  class="border border-1 border-gray rounded mt-1 acry-input form-control"
                  placeholder="名"
                  required
                />
              </div>
            </div>
          </div>
          <div class="d-flex flex-row gap-3">
            <div>
              <div class="mb-1 mt-1 text-start">
                <label for="inputNameKana" class="form-label fw-bold m-0">カナ</label>
                <input
                  type="text"
                  id="inputNameKana"
                  v-model="kana01"
                  class="border border-1 border-gray rounded mt-1 acry-input form-control"
                  placeholder="カナ"
                  required
                />
              </div>
            </div>
            <div>
              <div class="mb-1 mt-1 text-start">
                <label
                  for="inputName2Kana"
                  class="form-label m-0"
                  style="visibility: hidden"
                  >メイ</label
                >
                <input
                  type="text"
                  id="inputName2Kana"
                  v-model="kana02"
                  class="border border-1 border-gray rounded mt-1 acry-input form-control"
                  placeholder="メイ"
                  required
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="w-100">
          <hr/>
        </div>
      </div>
      <div class="row mt-1 mb-2">
        <div class="col-3 text-start">
          <span class="fw-bold">会社名</span>
        </div>
        <div class="col-7">
          <div class="text-start">
            <input
              type="text"
              id="address"
              class="border border-1 border-gray rounded mt-1 acry-input form-control"
              v-model="company_name"
              style="width: 616px"
              placeholder="〇〇株式会社"
            />
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="w-100">
          <hr/>
        </div>
      </div>
      <div class="row mt-1 mb-2">
        <div class="col-3 text-start">
          <span class="fw-bold">部署名</span>
          <!-- <span class="mustlbl ms-2">必須</span> -->
        </div>
        <div class="col-7">
          <div class="text-start">
            <input
              type="text"
              id="address"
              class="border border-1 border-gray rounded mt-1 acry-input form-control"
              v-model="department_name"
              style="width: 616px"
              placeholder="〇〇部"
            />
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="w-100">
          <hr/>
        </div>
      </div>

      <div class="row mt-1">
        <div class="col-3 text-start">
          <span class="fw-bold">住所</span><span class="mustlbl ms-2">必須</span>
        </div>
        <div class="col-7">
          <div class="text-start row">
            <span class="col-auto p-1" style="margin: auto 6px;">〒</span>
            <input
              type="text"
              id="inputCode"
              class="border border-1 border-gray rounded mt-0 acry-input"
              v-model="zip"
              maxlength="7"
              style="width: 129px"
              placeholder="0000000"
              required
            />
            <div class="col-auto" style="margin: auto 0px;">
              <button type="button" class="btn" style="background:#838FB1; color:white" v-on:click="findAddress">
                住所検索
              </button>
            </div>
          </div>

          <select
            class="text-start form-select mt-3"
            name="pref_id"
            id="inputCity"
            v-model="pref"
            style="width: 160px; height: 40px; font-size: 14px"
          >
            <option disabled value="default">都道府県を選択</option>

            <option value="1">北海道</option>
            <option value="2">青森県</option>
            <option value="3">岩手県</option>
            <option value="4">宮城県</option>
            <option value="5">秋田県</option>
            <option value="6">山形県</option>
            <option value="7">福島県</option>
            <option value="8">茨城県</option>
            <option value="9">栃木県</option>
            <option value="10">群馬県</option>
            <option value="11">埼玉県</option>
            <option value="12">千葉県</option>
            <option value="13">東京都</option>
            <option value="14">神奈川県</option>
            <option value="15">新潟県</option>
            <option value="16">富山県</option>
            <option value="17">石川県</option>
            <option value="18">福井県</option>
            <option value="19">山梨県</option>
            <option value="20">長野県</option>
            <option value="21">岐阜県</option>
            <option value="22">静岡県</option>
            <option value="23">愛知県</option>
            <option value="24">三重県</option>
            <option value="25">滋賀県</option>
            <option value="26">京都府</option>
            <option value="27">大阪府</option>
            <option value="28">兵庫県</option>
            <option value="29">奈良県</option>
            <option value="30">和歌山県</option>
            <option value="31">鳥取県</option>
            <option value="32">島根県</option>
            <option value="33">岡山県</option>
            <option value="34">広島県</option>
            <option value="35">山口県</option>
            <option value="36">徳島県</option>
            <option value="37">香川県</option>
            <option value="38">愛媛県</option>
            <option value="39">高知県</option>
            <option value="40">福岡県</option>
            <option value="41">佐賀県</option>
            <option value="42">長崎県</option>
            <option value="43">熊本県</option>
            <option value="44">大分県</option>
            <option value="45">宮崎県</option>
            <option value="46">鹿児島県</option>
            <option value="47">沖縄県</option>
          </select>

          <div class="text-start  mt-3">
            <input
              type="address"
              id="address"
              class="input border border-1 border-gray rounded mt-1 acry-input"
              v-model="addr01"
              placeholder="市町村名(例：大阪市北区)"
              style="width: 616px"
              required
            />
          </div>
          <div class="text-start  mt-3">
            <input
              type="address"
              id="address"
              class="input border border-1 border-gray rounded mt-1 acry-input"
              v-model="addr02"
              placeholder="番地・ビル名(例：西梅田1丁目6-8)"
              style="width: 616px"
            />
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="w-100">
          <hr/>
        </div>
      </div>

      <div class="row mt-1 mb-2">
        <div class="col-3 text-start">
          <span class="fw-bold">電話番号</span><span class="mustlbl ms-2">必須</span>
        </div>

        <div class="col-auto text-start">
          <input
            type="text"
            id="phone"
            class="input border border-1 border-gray rounded mt-1 acry-input"
            v-model="tel01"
            pattern="^[0-9]+$"
            style="width:100px"
            required
          />
        </div>
        <div class="col-auto p-0 m-0">
          <p class="text-dark m-0 p-0" style="line-height: 40px">-</p>
        </div>

        <div class="col-auto">
          <input
            type="text"
            id="phone"
            class="input border border-1 border-gray rounded mt-1 acry-input"
            v-model="tel02"
            pattern="^[0-9]+$"
            style="width:100px"
            required
          />
        </div>
        <div class="col-auto p-0 m-0">
          <p class="text-dark m-0 p-0" style="line-height: 40px">-</p>
        </div>

        <div class="col-auto">
          <input
            type="text"
            id="phone"
            class="input border border-1 border-gray rounded mt-1 acry-input"
            v-model="tel03"
            pattern="^[0-9]+$"
            style="width:100px"
            required
          />
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="w-100">
          <hr/>
        </div>
      </div>

      <div class="row justify-content-center mt-3 mb-3">
          <button class="acry-btn-primary-normal fw-bold" style="width:240px;height:56px;">{{ this.btnLbl }}</button>
      </div>

      <div class="w-100" style="height:40px;"></div>
    </form>
  </div>
</template>

<script>
import { User } from "@/js/User.js";


export default {
  name: "CenterViewShippingAdd_Ap",
  props: {},
  data() {
    return {
      company_name: "",
      department_name: "",
      name01: "",
      name02: "",
      kana01: "",
      kana02: "",
      tel01: null,
      tel02: null,
      tel03: null,
      email: null,
      zip: null,
      pref: null,
      addr01: "",
      addr02: "",
      form: {},
      btnLbl: "追加",
      activateSubmit: false,
      // result: {},
    };
  },
  created: function () {
    console.log(this.$store.state.editShippingData);
    if (this.$store.state.editShippingData) {
      this.btnLbl = "更新";
      this.company_name = this.$store.state.editShippingData.company_name;
      this.department_name = (this.$store.state.editShippingData.department_name)?this.$store.state.editShippingData.department_name:"";
      this.name01 = this.$store.state.editShippingData.name01;
      this.name02 = this.$store.state.editShippingData.name02;
      this.kana01 = this.$store.state.editShippingData.kana01;
      this.kana02 = this.$store.state.editShippingData.kana02;
      this.tel01 = this.$store.state.editShippingData.tel01;
      this.tel02 = this.$store.state.editShippingData.tel02;
      this.tel03 = this.$store.state.editShippingData.tel03;
      this.email = this.$store.state.editShippingData.email;
      this.zip01 = this.$store.state.editShippingData.zip01;
      this.zip02 = this.$store.state.editShippingData.zip02;
      this.zip = this.zip01 + this.zip02;
      this.pref = this.$store.state.editShippingData.pref;
      this.addr01 = this.$store.state.editShippingData.addr01;
      this.addr02 = (this.$store.state.editShippingData.addr02)?this.$store.state.editShippingData.addr02:"";
      if (!this.$store.state.editShippingData.other_deliv_id) {
        this.activateSubmit = true;
      }
    }
  },
  methods: {
    findAddress: function () {
      let YubinBango = require("yubinbango-core2");
      new YubinBango.Core(this.zip, (addr) => {
        this.pref = addr.region_id;
        this.addr01 = addr.locality + addr.street;
        this.addr02 = "";
      });
    },
    updateAction() {
    },

    async nextAction() {
      const form = document.getElementById("mainForm");
      if (!form.checkValidity()) {
        return;
      }

      let isAdd = !(this.$store.state.editShippingData);

      if (this.$store.state.editShippingData) {
        this.$store.state.editShippingData.name01 = this.name01;
        this.$store.state.editShippingData.name02 = this.name02;
        this.$store.state.editShippingData.company_name = this.company_name;
        this.$store.state.editShippingData.department_name = this.department_name;
        this.$store.state.editShippingData.kana01 = this.kana01;
        this.$store.state.editShippingData.kana02 = this.kana02;
        this.$store.state.editShippingData.tel01 = this.tel01;
        this.$store.state.editShippingData.tel02 = this.tel02;
        this.$store.state.editShippingData.tel03 = this.tel03;
        this.$store.state.editShippingData.email = this.email;
        this.$store.state.editShippingData.zip01 = this.zip.substring(0, 3);
        this.$store.state.editShippingData.zip02 = this.zip.substring(3, 7);
        this.$store.state.editShippingData.pref = this.pref;
        this.$store.state.editShippingData.addr01 = this.addr01;
        this.$store.state.editShippingData.addr02 = this.addr02;
      } else {
        const data = {
          isNew: true,
          name01: this.name01,
          name02: this.name02,
          company_name: this.company_name,
          department_name: this.department_name,
          kana01: this.kana01,
          kana02: this.kana02,
          tel01: this.tel01,
          tel02: this.tel02,
          tel03: this.tel03,
          email: this.email,
          zip01: this.zip.substring(0, 3),
          zip02: this.zip.substring(3, 7),
          pref: this.pref,
          addr01: this.addr01,
          addr02: this.addr02,
        };
        this.$store.commit("setEditShippingData", data);
      }

      this.$store.commit("showLoading");

      if( isAdd ){
        await User.addDestination(this.$store.state.editShippingData)
          .then(() => {
            this.$store.commit("showMessage", "配送先を追加しました");
            this.$store.commit("hideLoading");
            this.$store.commit("setEditShippingData", null);
            this.$store.commit("setShippingScreenType", "List");
          })
          .catch((error) => {
            this.$handleError("045", error, { hideLoading: true });
            return;
          });
      }else{
        await User.editDestination(this.$store.state.editShippingData)
            .then(() => {
              this.$store.commit("showMessage", "配送先を更新しました");
              this.$store.commit("hideLoading");
              this.$store.commit("setEditShippingData", null);
              this.$store.commit("setShippingScreenType", "List");
            })
            .catch((error) => {
              this.$handleError("046", error, { hideLoading: true });
              return;
            });
      }
    },
    // backAction() {
    //   if (
    //     this.$store.state.editShippingData &&
    //     !this.$store.state.editShippingData.other_deliv_id
    //   ) {
    //     this.$store.commit("setShippingScreenType", "User");
    //   } else {
    //     this.$store.commit("setShippingScreenType", "List");
    //   }
    // },
  },
};
</script>
<style scoped>
.shippingrow {
  width: 500px;
  margin: 0 auto;
}
.scroll {
  background-color: transparent;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  align-items: left;
  flex: 1;
  padding-right: 10px;
  padding-left: 10px;
}
.forminput {
  background: #e0dfe7;
  /* color: #7c88a9; */
  color:black;
}
.forminput:focus {
  background: #e0dfe7;
  /* color: #7c88a9; */
  color:black;
}
.mustlbl {
  color: white;
  background: #bc6665;
  border-radius: 3px;
  padding: 5px 12px 5px 12px;
}
</style>
